module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "bottomto"
    }
  }, [(_vm.mshow) ? _c('div', {
    staticClass: "share"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('a', {
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7c68420"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/shareView.vue
// module id = 54
// module chunks = 0